module.exports = __webpack_public_path__ + "static/media/coin-store-offer-badge.9abf69e7.png";